import { render, staticRenderFns } from "./form_historic_monetization_component.vue?vue&type=template&id=cde212e2&scoped=true"
import script from "./form_historic_monetization_component.vue?vue&type=script&lang=js"
export * from "./form_historic_monetization_component.vue?vue&type=script&lang=js"
import style0 from "./form_historic_monetization_component.vue?vue&type=style&index=0&id=cde212e2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde212e2",
  null
  
)

export default component.exports